(function () {
  var PRODUCT_MEDIA_RETRIES = 20;
  var reducedMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function toArray(items) {
    return Array.prototype.slice.call(items || []);
  }

  function getMotionBehavior() {
    return reducedMotionQuery && reducedMotionQuery.matches ? 'auto' : 'smooth';
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function hydrateImage(image) {
    if (!image) {
      return;
    }

    if (image.dataset.src) {
      image.setAttribute('src', image.dataset.src);
      image.removeAttribute('data-src');
    }

    if (image.dataset.srcset) {
      image.setAttribute('srcset', image.dataset.srcset);
      image.removeAttribute('data-srcset');
    }

    if (image.dataset.sizes) {
      image.setAttribute('sizes', image.dataset.sizes);
      image.removeAttribute('data-sizes');
    }
  }

  function hydrateSlide(slide) {
    if (!slide) {
      return;
    }

    toArray(slide.querySelectorAll('img[data-src], img[data-srcset], img[data-sizes]')).forEach(hydrateImage);
  }

  function requestIdle(callback, timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, {
        timeout: timeout || 1500
      });
      return;
    }

    window.setTimeout(callback, timeout || 1500);
  }

  function afterLayoutReady(callback) {
    var productStylesheet = document.querySelector('link[href*="custom-product.css"]');
    var resolved = false;

    function finish() {
      if (resolved) {
        return;
      }

      resolved = true;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(callback);
      });
    }

    if (!productStylesheet || productStylesheet.sheet) {
      finish();
      return;
    }

    productStylesheet.addEventListener('load', finish, { once: true });
    productStylesheet.addEventListener('error', finish, { once: true });
    window.setTimeout(finish, 1200);
  }

  function waitForFlickity(callback, attempts) {
    var remainingAttempts = typeof attempts === 'number' ? attempts : 30;

    if (window.Flickity) {
      callback(true);
      return;
    }

    if (remainingAttempts <= 0) {
      callback(false);
      return;
    }

    window.setTimeout(function () {
      waitForFlickity(callback, remainingAttempts - 1);
    }, 100);
  }

  function hasSlick() {
    return !!(window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === 'function');
  }

  function waitForSlick(callback, attempts) {
    var remainingAttempts = typeof attempts === 'number' ? attempts : 30;

    if (hasSlick()) {
      callback(true);
      return;
    }

    if (remainingAttempts <= 0) {
      callback(false);
      return;
    }

    window.setTimeout(function () {
      waitForSlick(callback, remainingAttempts - 1);
    }, 100);
  }

  function usesLegacyHomepageSliders() {
    if (!document.body) {
      return false;
    }

    return (
      document.body.classList.contains('template-index') ||
      document.body.classList.contains('page-lp') ||
      document.body.classList.contains('lp-blyss')
    );
  }

  function destroyFlickity(element) {
    if (!element || !window.Flickity || !window.Flickity.data) {
      return;
    }

    var instance = window.Flickity.data(element);

    if (instance && typeof instance.destroy === 'function') {
      instance.destroy();
    }
  }

  function createSlick(element, options) {
    if (!element || !hasSlick()) {
      return null;
    }

    var $element = window.jQuery(element);

    if ($element.hasClass('slick-initialized')) {
      $element.slick('setPosition');
      return $element;
    }

    destroyFlickity(element);
    $element.slick(options);
    return $element;
  }

  function mountDeferredContent(container) {
    if (!container || container.getAttribute('data-bly-deferred-mounted') === 'true') {
      return;
    }

    var template = container.querySelector('template[data-deferred-content-template]');
    var placeholder = container.querySelector('[data-deferred-content-placeholder]');

    if (!template || !placeholder) {
      return;
    }

    var fragment = template.content.cloneNode(true);
    var refreshTarget = container.getAttribute('data-deferred-refresh');

    container.setAttribute('data-bly-deferred-mounted', 'true');
    placeholder.parentNode.insertBefore(fragment, placeholder);
    placeholder.parentNode.removeChild(placeholder);
    container.classList.add('is-loaded');

    if (refreshTarget === 'yotpo') {
      refreshYotpoWidgets();
    } else if (refreshTarget === 'seal') {
      refreshSealWidgets();
    }

    container.dispatchEvent(
      new CustomEvent('bly:deferred:mounted', {
        bubbles: true,
        detail: {
          container: container,
          refresh: refreshTarget || ''
        }
      })
    );
  }

  function initDeferredContent(root) {
    toArray(root.querySelectorAll('[data-deferred-content]')).forEach(function (container) {
      if (container.getAttribute('data-bly-deferred-ready') === 'true') {
        return;
      }

      container.setAttribute('data-bly-deferred-ready', 'true');

      var mode = container.getAttribute('data-deferred-mode') || 'viewport';
      var timeout = parseInt(container.getAttribute('data-deferred-timeout'), 10);
      var rootMargin = container.getAttribute('data-deferred-root-margin') || '250px 0px';

      if (mode === 'idle') {
        requestIdle(function () {
          mountDeferredContent(container);
        }, Number.isNaN(timeout) ? 1400 : timeout);
        return;
      }

      if (mode === 'interaction') {
        var interactionRoot = container.closest('[data-deferred-interaction-root]') || container;
        var cleanupHandlers = [];
        var mounted = false;

        function mountOnInteraction() {
          if (mounted) {
            return;
          }

          mounted = true;
          cleanupHandlers.forEach(function (cleanup) {
            cleanup();
          });
          mountDeferredContent(container);
        }

        ['pointerdown', 'touchstart', 'focusin', 'mouseenter'].forEach(function (eventName) {
          function handleInteraction() {
            mountOnInteraction();
          }

          interactionRoot.addEventListener(eventName, handleInteraction, {
            once: true,
            passive: eventName !== 'focusin'
          });

          cleanupHandlers.push(function () {
            interactionRoot.removeEventListener(eventName, handleInteraction);
          });
        });

        if (!Number.isNaN(timeout) && timeout > 0) {
          window.setTimeout(mountOnInteraction, timeout);
        }

        return;
      }

      if (!('IntersectionObserver' in window)) {
        mountDeferredContent(container);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            observer.disconnect();
            mountDeferredContent(container);
          });
        },
        {
          rootMargin: rootMargin
        }
      );

      observer.observe(container);
    });
  }

  function initLandingTabs(root) {
    toArray(root.querySelectorAll('.toggle.desktopTab')).forEach(function (toggle) {
      if (toggle.getAttribute('data-bly-tabs-ready') === 'true') {
        return;
      }

      var tabs = toArray(toggle.querySelectorAll('.tabs .tab'));
      var panels = toArray(toggle.querySelectorAll('.panels .panel'));

      if (!tabs.length || !panels.length) {
        return;
      }

      toggle.setAttribute('data-bly-tabs-ready', 'true');

      function show(index) {
        tabs.forEach(function (tab, tabIndex) {
          tab.classList.toggle('active', tabIndex === index);
        });

        panels.forEach(function (panel, panelIndex) {
          panel.style.display = panelIndex === index ? '' : 'none';
        });
      }

      tabs.forEach(function (tab, index) {
        tab.setAttribute('tabindex', '0');
        tab.addEventListener('click', function () {
          show(index);
        });
        tab.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') {
            return;
          }

          event.preventDefault();
          show(index);
        });
      });

      var activeIndex = 0;
      tabs.some(function (tab, index) {
        if (!tab.classList.contains('active')) {
          return false;
        }

        activeIndex = index;
        return true;
      });

      show(activeIndex);
    });
  }

  function initLandingProductThumbRails(root) {
    toArray(root.querySelectorAll('.Product__SlideshowNavScroller.main-carousel')).forEach(function (scroller) {
      if (scroller.getAttribute('data-bly-thumb-rail-ready') === 'true') {
        return;
      }

      scroller.setAttribute('data-bly-thumb-rail-ready', 'true');

      function scrollSelected() {
        var selectedThumb = scroller.querySelector('.Product__SlideshowNavImage.is-selected');
        var nextLeft;
        var maxLeft;

        if (!selectedThumb) {
          return;
        }

        nextLeft = selectedThumb.offsetLeft - (scroller.clientWidth - selectedThumb.clientWidth) / 2;
        maxLeft = Math.max(scroller.scrollWidth - scroller.clientWidth, 0);
        nextLeft = Math.max(0, Math.min(nextLeft, maxLeft));

        if (typeof scroller.scrollTo === 'function') {
          scroller.scrollTo({
            left: nextLeft,
            behavior: getMotionBehavior()
          });
          return;
        }

        scroller.scrollLeft = nextLeft;
      }

      var observer = new MutationObserver(function () {
        scrollSelected();
      });

      observer.observe(scroller, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });

      scroller.addEventListener('click', function (event) {
        if (!event.target.closest('.Product__SlideshowNavImage')) {
          return;
        }

        window.requestAnimationFrame(scrollSelected);
      });

      scrollSelected();
    });
  }

  function waitForProductCarousel(slideshow, callback, attempt) {
    var retryCount = attempt || 0;
    var flickity = window.Flickity && window.Flickity.data ? window.Flickity.data(slideshow) : null;

    if (flickity) {
      callback(flickity);
      return;
    }

    if (retryCount >= PRODUCT_MEDIA_RETRIES) {
      return;
    }

    window.setTimeout(function () {
      waitForProductCarousel(slideshow, callback, retryCount + 1);
    }, 100);
  }

  function initProductMedia(root) {
    toArray(root.querySelectorAll('.Product__Slideshow')).forEach(function (slideshow) {
      if (slideshow.getAttribute('data-bly-media-ready') === 'true') {
        return;
      }

      slideshow.setAttribute('data-bly-media-ready', 'true');

      var slides = toArray(slideshow.querySelectorAll('.Product__SlideItem'));
      var productRoot = slideshow.closest('.Product');

      function getSelectedIndex() {
        var flickity = window.Flickity && window.Flickity.data ? window.Flickity.data(slideshow) : null;

        if (flickity) {
          return flickity.selectedIndex;
        }

        var selectedSlide = slideshow.querySelector('.Product__SlideItem.is-selected');
        return Math.max(slides.indexOf(selectedSlide), 0);
      }

      function hydrateIndex(index) {
        if (index < 0 || index >= slides.length) {
          return;
        }

        hydrateSlide(slides[index]);
      }

      function hydrateAdjacent(index) {
        requestIdle(function () {
          hydrateIndex(index - 1);
          hydrateIndex(index + 1);
        }, 600);
      }

      function hydrateMediaById(mediaId) {
        if (!mediaId) {
          return;
        }

        hydrateSlide(slideshow.querySelector('[data-media-id="' + mediaId + '"]'));
      }

      hydrateIndex(getSelectedIndex());

      if (productRoot) {
        productRoot.addEventListener('variant:changed', function () {
          window.setTimeout(function () {
            hydrateIndex(getSelectedIndex());
          }, 50);
        });

        productRoot.addEventListener('click', function (event) {
          var navImage = event.target.closest('.Product__SlideshowNavImage');

          if (!navImage) {
            return;
          }

          hydrateMediaById(navImage.getAttribute('data-media-id'));
        });
      }

      waitForProductCarousel(slideshow, function (flickity) {
        if (slideshow.getAttribute('data-bly-media-bound') === 'true') {
          return;
        }

        slideshow.setAttribute('data-bly-media-bound', 'true');

        function handleSelect() {
          hydrateIndex(flickity.selectedIndex);
          hydrateAdjacent(flickity.selectedIndex);
        }

        flickity.on('select', handleSelect);
      });
    });
  }

  function createFlickity(element, options) {
    if (!window.Flickity) {
      return null;
    }

    var existingInstance = window.Flickity.data(element);

    if (existingInstance) {
      existingInstance.resize();
      return existingInstance;
    }

    return new window.Flickity(element, options);
  }

  function initCustomerReviews(root) {
    if (usesLegacyHomepageSliders()) {
      toArray(root.querySelectorAll('.testimonialSection .Review_outer')).forEach(function (carousel) {
        if (carousel.getAttribute('data-bly-carousel-ready') === 'true' || carousel.children.length <= 1) {
          return;
        }

        carousel.setAttribute('data-bly-carousel-pending', 'true');

        afterLayoutReady(function () {
          waitForSlick(function (hasLegacySlider) {
            var slider;

            if (!hasLegacySlider) {
              carousel.removeAttribute('data-bly-carousel-pending');
              return;
            }

            slider = createSlick(carousel, {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: carousel.getAttribute('data-show-arrows') === 'true',
              dots: true,
              infinite: true,
              adaptiveHeight: false,
              responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1
                  }
                }
              ]
            });

            if (!slider) {
              carousel.removeAttribute('data-bly-carousel-pending');
              return;
            }

            carousel.removeAttribute('data-bly-carousel-pending');
            carousel.setAttribute('data-bly-carousel-ready', 'true');
            slider.slick('setPosition');
          });
        });
      });

      return;
    }

    toArray(root.querySelectorAll('.testimonialSection .Review_outer')).forEach(function (carousel) {
      if (carousel.getAttribute('data-bly-carousel-ready') === 'true' || carousel.getAttribute('data-bly-carousel-pending') === 'true') {
        return;
      }

      if (carousel.children.length <= 1) {
        return;
      }

      carousel.setAttribute('data-bly-carousel-pending', 'true');

      afterLayoutReady(function () {
        waitForFlickity(function (hasFlickity) {
          var instance;

          if (!hasFlickity) {
            carousel.removeAttribute('data-bly-carousel-pending');
            return;
          }

          instance = createFlickity(carousel, {
            cellSelector: '.review-container',
            contain: true,
            wrapAround: true,
            pageDots: true,
            prevNextButtons: carousel.getAttribute('data-show-arrows') === 'true',
            draggable: true
          });

          if (!instance) {
            carousel.removeAttribute('data-bly-carousel-pending');
            return;
          }

          carousel.removeAttribute('data-bly-carousel-pending');
          carousel.setAttribute('data-bly-carousel-ready', 'true');

          function syncReviewCardHeights() {
            var cards = toArray(carousel.querySelectorAll('.review-container'));

            if (!cards.length) {
              return;
            }

            cards.forEach(function (card) {
              card.style.height = '';
            });

            var maxHeight = cards.reduce(function (largest, card) {
              return Math.max(largest, Math.ceil(card.getBoundingClientRect().height));
            }, 0);

            if (!maxHeight) {
              return 0;
            }

            cards.forEach(function (card) {
              card.style.height = maxHeight + 'px';
            });

            return maxHeight;
          }

          function resizeReviews() {
            var maxHeight = syncReviewCardHeights();
            var currentIndex = instance && typeof instance.selectedIndex === 'number' ? instance.selectedIndex : 0;

            if (instance && typeof instance.resize === 'function') {
              instance.resize();
            }

            if (instance && typeof instance.reposition === 'function') {
              instance.reposition();
            }

            if (maxHeight && instance && instance.viewport) {
              instance.viewport.style.height = maxHeight + 'px';
            }

            if (instance && typeof instance.select === 'function') {
              instance.select(currentIndex, false, true);
            }
          }

          function scheduleResize() {
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(resizeReviews);
            });
          }

          if (instance && typeof instance.on === 'function') {
            instance.on('ready', resizeReviews);
            instance.on('settle', resizeReviews);
          }

          scheduleResize();

          window.addEventListener('load', resizeReviews, {
            once: true
          });

          window.addEventListener('pageshow', scheduleResize);
          window.addEventListener('resize', resizeReviews);

          document.addEventListener('visibilitychange', function () {
            if (document.visibilityState !== 'visible') {
              return;
            }

            scheduleResize();
          });

          if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
            document.fonts.ready.then(resizeReviews);
          }

          window.setTimeout(scheduleResize, 120);
          window.setTimeout(scheduleResize, 400);
          window.setTimeout(scheduleResize, 900);

          if ('ResizeObserver' in window) {
            var reviewResizeObserver = new window.ResizeObserver(scheduleResize);

            reviewResizeObserver.observe(carousel);

            toArray(carousel.querySelectorAll('.review-container, .main-content_for_review')).forEach(function (element) {
              reviewResizeObserver.observe(element);
            });
          }

          if ('IntersectionObserver' in window) {
            var reviewIntersectionObserver = new window.IntersectionObserver(function (entries, observer) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) {
                  return;
                }

                scheduleResize();
                observer.disconnect();
              });
            }, {
              rootMargin: '200px 0px'
            });

            reviewIntersectionObserver.observe(carousel);
          }
        });
      });
    });
  }

  function initLandingTestimonials(root) {
    toArray(root.querySelectorAll('.testimonial-outer')).forEach(function (carousel) {
      if (carousel.getAttribute('data-bly-carousel-ready') === 'true') {
        return;
      }

      carousel.setAttribute('data-bly-carousel-ready', 'true');

      if (carousel.children.length <= 1) {
        return;
      }

      if (usesLegacyHomepageSliders()) {
        waitForSlick(function (hasLegacySlider) {
          var slider;

          if (!hasLegacySlider) {
            return;
          }

          slider = createSlick(carousel, {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: true,
            adaptiveHeight: false
          });

          if (!slider) {
            return;
          }

          carousel.setAttribute('data-bly-carousel-ready', 'true');
          slider.slick('setPosition');
        });

        return;
      }

      createFlickity(carousel, {
        cellSelector: '.testimonial',
        contain: true,
        wrapAround: true,
        pageDots: true,
        prevNextButtons: true,
        draggable: true,
        adaptiveHeight: true
      });
    });
  }

  function appendAutoplayParams(url) {
    if (!url) {
      return '';
    }

    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return url + separator + 'autoplay=1&mute=1';
  }

  function buildVideoElement(poster) {
    var videoUrl = poster.getAttribute('data-video-url');
    var tagType = poster.getAttribute('data-video-tag-type');
    var mediaElement;

    if (!videoUrl || !tagType) {
      return null;
    }

    if (tagType === 'video') {
      mediaElement = document.createElement('video');
      mediaElement.className = 'videoTag';
      mediaElement.width = 1000;
      mediaElement.height = 500;
      mediaElement.controls = true;
      mediaElement.preload = 'metadata';
      mediaElement.autoplay = true;
      mediaElement.playsInline = true;

      var source = document.createElement('source');
      source.src = videoUrl + '#t=0.1';
      mediaElement.appendChild(source);
    } else if (tagType === 'iframe') {
      mediaElement = document.createElement('iframe');
      mediaElement.className = 'videoIframe';
      mediaElement.width = '100%';
      mediaElement.height = '500';
      mediaElement.src = appendAutoplayParams(videoUrl);
      mediaElement.setAttribute('frameborder', '0');
      mediaElement.setAttribute(
        'allow',
        'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      );
      mediaElement.setAttribute('allowfullscreen', '');
    }

    return mediaElement || null;
  }

  function initLandingVideos(root) {
    toArray(root.querySelectorAll('.multiVideoNew, .multiVideo.legacyVideoSection')).forEach(function (section) {
      if (section.getAttribute('data-bly-videos-ready') !== 'true') {
        section.setAttribute('data-bly-videos-ready', 'true');

        section.addEventListener('click', function (event) {
          var poster = event.target.closest('.videoPoster');

          if (!poster || poster.getAttribute('data-bly-video-loaded') === 'true') {
            return;
          }

          var mediaElement = buildVideoElement(poster);

          if (!mediaElement) {
            return;
          }

          poster.setAttribute('data-bly-video-loaded', 'true');
          poster.hidden = true;
          poster.insertAdjacentElement('afterend', mediaElement);

          var carousel = section.querySelector('.video-carousel-new, .video-carousel');
          var flickity = carousel && window.Flickity && window.Flickity.data ? window.Flickity.data(carousel) : null;
          var slick = carousel && hasSlick() ? window.jQuery(carousel) : null;

          if (flickity) {
            window.setTimeout(function () {
              flickity.resize();
            }, 50);
          } else if (slick && slick.hasClass('slick-initialized')) {
            window.setTimeout(function () {
              slick.slick('setPosition');
            }, 50);
          }
        });
      }

      toArray(section.querySelectorAll('.video-carousel-new, .video-carousel')).forEach(function (carousel) {
        if (carousel.getAttribute('data-bly-carousel-ready') === 'true') {
          return;
        }

        if (carousel.classList.contains('video-carousel') && window.innerWidth >= 767) {
          return;
        }

        carousel.setAttribute('data-bly-carousel-ready', 'true');

        if (carousel.children.length <= 1) {
          return;
        }

        if (usesLegacyHomepageSliders()) {
          waitForSlick(function (hasLegacySlider) {
            var slider;

            if (!hasLegacySlider) {
              return;
            }

            slider = createSlick(carousel, {
              slidesToShow: 4,
              slidesToScroll: 1,
              arrows: true,
              dots: false,
              infinite: true,
              adaptiveHeight: false,
              responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 3
                  }
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 3,
                    centerMode: true,
                    dots: true
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                    centerMode: true,
                    dots: true
                  }
                },
                {
                  breakpoint: 481,
                  settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    dots: true
                  }
                }
              ]
            });

            if (!slider) {
              return;
            }

            slider.slick('setPosition');
          });

          return;
        }

        createFlickity(carousel, {
          cellSelector: '.videoBox',
          contain: true,
          wrapAround: true,
          pageDots: true,
          prevNextButtons: true,
          draggable: true
        });
      });
    });
  }

  function initLpProductCarousel(slider) {
    if (!slider || slider.getAttribute('data-bly-carousel-ready') === 'true') {
      if (slider && hasSlick()) {
        var existingSlick = window.jQuery(slider);

        if (existingSlick.hasClass('slick-initialized')) {
          existingSlick.slick('setPosition');
          return;
        }
      }

      if (slider && window.Flickity && window.Flickity.data) {
        var existingInstance = window.Flickity.data(slider);

        if (existingInstance) {
          existingInstance.resize();
        }
      }

      return;
    }

    slider.setAttribute('data-bly-carousel-ready', 'true');

    if (slider.children.length <= 1) {
      return;
    }

    if (usesLegacyHomepageSliders()) {
      waitForSlick(function (hasLegacySlider) {
        var legacySlider;

        if (!hasLegacySlider) {
          return;
        }

        legacySlider = createSlick(slider, {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: false,
          adaptiveHeight: false
        });

        if (!legacySlider) {
          return;
        }

        legacySlider.slick('setPosition');
      });

      return;
    }

    createFlickity(slider, {
      cellSelector: '.product-item',
      contain: true,
      wrapAround: false,
      pageDots: true,
      prevNextButtons: false,
      adaptiveHeight: true,
      draggable: true
    });
  }

  function initLandingProductAnchorLinks(root) {
    toArray(root.querySelectorAll('a[href="#landing-product-section"]')).forEach(function (link) {
      if (link.getAttribute('data-bly-anchor-ready') === 'true') {
        return;
      }

      link.setAttribute('data-bly-anchor-ready', 'true');

      link.addEventListener('click', function (event) {
        var target = document.getElementById('landing-product-section');

        if (!target) {
          return;
        }

        event.preventDefault();

        var top = target.getBoundingClientRect().top + window.pageYOffset - 70;
        window.scrollTo({
          top: top,
          behavior: getMotionBehavior()
        });
      });
    });
  }

  function initLpProductSections(root) {
    initLandingProductAnchorLinks(root);

    toArray(root.querySelectorAll('.lp-product-section')).forEach(function (section) {
      if (section.getAttribute('data-bly-tabs-ready') === 'true') {
        return;
      }

      var tabs = toArray(section.querySelectorAll('.tab-group .tab'));
      var panels = toArray(section.querySelectorAll('.panel-group .panel'));

      if (!tabs.length || !panels.length) {
        return;
      }

      section.setAttribute('data-bly-tabs-ready', 'true');

      function showPanel(index) {
        tabs.forEach(function (tab, tabIndex) {
          tab.classList.toggle('is-active', tabIndex === index);
        });

        panels.forEach(function (panel, panelIndex) {
          panel.classList.toggle('is-show', panelIndex === index);
        });

        initLpProductCarousel(panels[index] ? panels[index].querySelector('.product-slider') : null);
      }

      tabs.forEach(function (tab, index) {
        tab.setAttribute('tabindex', '0');
        tab.addEventListener('click', function () {
          showPanel(index);
        });
        tab.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') {
            return;
          }

          event.preventDefault();
          showPanel(index);
        });
      });

      var activeIndex = 0;
      tabs.some(function (tab, index) {
        if (!tab.classList.contains('is-active')) {
          return false;
        }

        activeIndex = index;
        return true;
      });

      showPanel(activeIndex);
    });
  }

  function refreshYotpoWidgets() {
    window.setTimeout(function () {
      if (
        window.yotpoWidgetsContainer &&
        typeof window.yotpoWidgetsContainer.initWidgets === 'function'
      ) {
        window.yotpoWidgetsContainer.initWidgets();
        return;
      }

      if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
        window.yotpo.initWidgets();
        return;
      }

      if (window.Yotpo && typeof window.Yotpo.refreshWidgets === 'function') {
        window.Yotpo.refreshWidgets();
      }
    }, 50);
  }

  function refreshSealWidgets() {
    [0, 300, 1000].forEach(function (delay) {
      window.setTimeout(function () {
        if (window.SealSubs && typeof window.SealSubs.refresh === 'function') {
          window.SealSubs.refresh();
        }
      }, delay);
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;

    initDeferredContent(scope);
    initLandingTabs(scope);
    initLandingProductThumbRails(scope);
    initProductMedia(scope);
    initCustomerReviews(scope);
    initLandingTestimonials(scope);
    initLandingVideos(scope);
    initLpProductSections(scope);
  }

  onReady(function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();
